exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.apex-chart-container[data-v-771ce6f8] {\n    width: 100%; /* Ustaw szerokość na 100% */\n}\n", ""]);

// exports
